import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import LocalizedStrings from 'react-localization';
import { CustomFormControl, } from '../../../../StyledComponents';
import { ClientLanguage, getClientLanguageAsString } from "../../../../../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        periodFrom: "Startdatum*",

        periodTo: "Enddatum*",

        periodRequired: "Angabe ist erforderlich",
        periodValidationError: "Bitte geben Sie einen gültigen Wert an",
    },
    en:
    {
        periodFrom: "Start date*",

        periodTo: "End date*",

        periodRequired: "Information required",
        periodValidationError: "Please enter a valid value",
    }
});

function setLanguage(clientLanguage): void {
    switch(clientLanguage) { 
        case ClientLanguage.German: { 
           locStrings.setLanguage('de');
           break; 
        } 
        case ClientLanguage.English: { 
           locStrings.setLanguage('en'); 
           break; 
        } 
        // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
    } 
}

export const Schema = (clientLanguage) => Yup.object().shape({
    periodFrom: Yup.date()
        .when("PeriodFromIsValid", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.typeError(locStrings.periodValidationError);
              },
        })
        .when("InformationIsRequired", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.required(locStrings.periodRequired);
              },
        }),
    periodTo: Yup.date()
        .when("PeriodToIsValid", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.typeError(locStrings.periodValidationError);
              },
        })
        .when("InformationIsRequired", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.required(locStrings.periodRequired);
              },
        }),
});

export const PeriodMandatorySubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings, clientLanguage } = props;

    setLanguage(clientLanguage);

    function getClientLanguage(): string { 
        return getClientLanguageAsString(clientLanguage); 
    } 
    
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formPeriodFrom">
                    <Form.Label className={"FormPeriodFromText"}>{locStrings.periodFrom}</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        type="date"
                        name="periodFrom"
                        value={values.periodFrom}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.periodFrom && !errors.periodFrom}
                        isInvalid={touched.periodFrom && errors.periodFrom}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.periodFrom}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formPeriodTo">
                <Form.Label className={"FormPeriodToText"}>{locStrings.periodTo}</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        type="date"
                        name="periodTo"
                        value={values.periodTo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.periodTo && !errors.periodTo}
                        isInvalid={touched.periodTo && errors.periodTo}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.periodTo}
                    </Form.Control.Feedback>
                </Form.Group>
          </Row>
        </>
    );
};